import { ChartTicks } from '/src/lib/types';

/**
 * Ticks
 */

export type TicksProps = ChartTicks;

export class Ticks implements TicksProps {
  number?: number;
  format?: string;

  constructor(number?: number, format?: string) {
    this.number = number;
    this.format = format;
  }
}
